import { Card, CardContent, Typography } from "@mui/material";

const CardLayout = ({ title, value }) => {
  return (
    <Card
      sx={{
        maxWidth: 180,
        height: 90,
        width: "70%",
        textAlign: "center",
        marginRight: "10px",
        padding: 1.5,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "&:hover": { boxShadow: 6, backgroundColor: "#f5f5f5" },
      }}
    >
      <CardContent sx={{ padding: "2px" }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: "1.2rem",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {" "}
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "1.0rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {value || ""}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardLayout;
